import {
  StreamErrorIds
} from '../utils/utils';
import { Messages } from '../../../../api/api-messages';

export const messagingService = {
  async uploadAsset (file, channel, accessToken) {
    const { id: channelId } = channel;
    const { name: fileName } = file;

    return new Promise((resolve) => {
      const encodedFileName = encodeURIComponent(fileName);
      Messages.uploadAttachment(channelId, encodedFileName, accessToken, (response) => {
        if (200 !== response.statusCode) {
          return resolve(false);
        }

        const {
          canonical_url: canonicalUrl,
          presigned_url: presignedUrl
        } = response;

        fetch(presignedUrl, {
          method: 'PUT',
          body: file,
          headers: { 'Content-Type': file.type }
        })
          .then((uploadResponse) => {
            if (!uploadResponse.ok) {
              return resolve(false);
            }

            Messages.uploadAttachmentCompleted(canonicalUrl, accessToken, (completedResponse) => {
              if (200 !== completedResponse.statusCode) {
                return resolve(false);
              }
              return resolve({
                file: canonicalUrl,
                thumb_url: canonicalUrl
              });
            });
          });
      });
    });
  },

  async sendMessage (message, channel, generateMessageMetadata, clearInputErrors, addInputErrorIds) {
    try {
      const response = await channel.sendMessage({
        ...message,
        metadata: generateMessageMetadata()
      });
      const responseType = response.message.type;

      clearInputErrors();
      if ('error' === responseType) {
        const errorMessage = response.message?.text;
        if (errorMessage) {
          addInputErrorIds([{
            id: StreamErrorIds.silent_error,
            customMessage: errorMessage
          }]);
        } else {
          addInputErrorIds([{ id: StreamErrorIds.generic }]);
        }
      }
    } catch (e) {
      addInputErrorIds([{ id: StreamErrorIds.generic }]);
    }
  }
};
